<script lang="ts">
  import { faCheck, faCircle, faFlag } from '@fortawesome/free-solid-svg-icons'
  import Fa from 'svelte-fa'
  import { state } from '../Game/State'
  import type { VoteStatus } from '../shared/codecs/Vote'
  import { hslFromString } from '../utilities/helpers'
  export let name: string
  export let photoURL: string | undefined = undefined
  export let vote: VoteStatus = 'pending'

  let usePhoto = !!photoURL
  const voteColor = (vote: VoteStatus): string => {
    switch (vote) {
      case 'red':
      case 'amber':
      case 'green':
        return `var(--${vote}-light)`
      default:
        return 'var(--tsf-washed-grey)'
    }
  }
  const generateStyle = ({ vote, usePhoto }: { vote: VoteStatus; usePhoto: boolean }): string => {
    if (['green', 'amber', 'red'].includes(vote)) {
      return `border: 2px solid ${voteColor(vote)};`
    } else {
      return ''
    }
  }
</script>

<div
  class="playerContainer"
  style={generateStyle({
    vote,
    usePhoto,
  })}
>
  {#if usePhoto}
    <img
      src={photoURL}
      alt={name}
      on:error={() => {
        usePhoto = false
      }}
    />
  {:else}
    <div class={`photoless-player`} style={`background-color: ${hslFromString(name)};`}>
      {name.charAt(0)}
    </div>
  {/if}
  {#if vote === 'cast'}
    <div class="voteIcon voteCastIcon">
      <Fa icon={faCheck} style={'stroke: white; stroke-width: 1rem;'} />
    </div>
  {:else if vote === 'green' || vote === 'amber' || vote === 'red'}
    <div class={`voteIcon`} style={`color: ${voteColor(vote)}`}>
      <Fa icon={faCircle} />
    </div>
  {:else if $state.show}
    <div class="voteIcon voteAbstainedIcon">
      <Fa icon={faFlag} />
    </div>
  {/if}
</div>

<style>
  .playerContainer {
    --diameter: 5rem;
    --outer-width: 0.2rem;
    margin: 0em 0.1em;
    box-shadow: 1px 4px 6px rgba(10, 30, 60, 0.15);
    width: var(--diameter);
    height: var(--diameter);
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid transparent;
  }

  .playerContainer + .playerContainer {
    margin-left: 0.5rem;
  }

  .photoless-player {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--tsf-white);
    width: var(--diameter);
    height: var(--diameter);
    font-size: 2rem;
    box-sizing: border-box;
  }

  img {
    width: var(--diameter);
    height: var(--diameter);
  }

  .playerContainer {
    position: relative;
  }

  .voteCastIcon {
    color: green;
    width: 2rem;
    height: 2rem;
    font-size: 2rem;
    stroke: white;
  }

  .voteIcon {
    position: absolute;
    z-index: 0;
    bottom: 0.75rem;
    right: 0.75rem;
  }

  .voteAbstainedIcon {
    color: white;
  }
</style>
